"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactDetails = void 0;
var ContactDetails = /** @class */ (function () {
    function ContactDetails() {
        this.title = "";
        this.firstName = "";
        this.surname = "";
        this.maidenName = "";
        this.preferredName = "";
        this.dob = "";
        this.gender = "";
        this.email = "";
        this.telephone = "";
        this.address = "";
        this.address2 = "";
        this.town = "";
        this.country = "";
        this.postCode = "";
        this.mobile = "";
        this.marketingEmail = false;
        this.marketingSMS = false;
        this.marketingPhone = false;
        this.marketingPost = false;
    }
    return ContactDetails;
}());
exports.ContactDetails = ContactDetails;
//# sourceMappingURL=ContactDetails.js.map